
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/living/purchase-pass",
      function () {
        return require("private-next-pages/living/purchase-pass.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/living/purchase-pass"])
      });
    }
  